// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu9/Item.css
// module id = 2041
// module chunks = 0